import { useDecision } from '@optimizely/react-sdk';
import { FEATURES } from 'shared/app/components/optimizely/optimizely-keys';

const useDaiboExperiment = () => {
  useDecision(FEATURES.DAIBO_EXPERIMENT);
  return {};
};

export default useDaiboExperiment;
